import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { NoteDTO } from "../../../api/api";
import type { ProviderResponse } from "./providersApi";
import { updateProviderNotes } from "./providersApi";

export const useUpdateProviderNotes = (providerId: string) => {
  const queryClient = useQueryClient();

  const updateProviderNotesMutation = useMutation<ProviderResponse, unknown, NoteDTO[]>({
    mutationFn: (notes) => updateProviderNotes(providerId, notes),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["providers"] });
    },
  });

  return {
    updateNotes: (notes: NoteDTO[]) => updateProviderNotesMutation.mutateAsync(notes),
  };
};
